import * as React from 'react';
import { isDev } from '../../utils/envCheck';

export interface IconProps {
  className?: string;
  iconType: string;
  isAriaHidden?: boolean;
  ariaLabel?: string;
  title?: string;
}

// --- MAGIN: Bygg ett automatiskt ikon-register ---
const commonIcons = require.context('sos-common/gfx/icons', true, /\.svg$/);
const localIcons = require.context('../../../gfx/icons', true, /\.svg$/);

const iconsMap: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {};

// Hjälpfunktion för att städa namnen
const registerIcons = (context: __WebpackModuleApi.RequireContext) => {
  context.keys().forEach((key) => {
    // Tar bort './' i början och '.svg' i slutet, behåller undermappar
    const name = key.replace('./', '').replace('.svg', '');
    iconsMap[name] = context(key).default;
  });
};

registerIcons(commonIcons);
try {
  registerIcons(localIcons);
} catch (e) {
  // Ignorera om lokal mapp saknas
}

export class Icon extends React.Component<IconProps> {
  static defaultProps = {
    className: '',
    ariaLabel: '',
    isAriaHidden: true,
  };

  public render() {
    const { className, iconType, isAriaHidden, ariaLabel, title } = this.props;

    const SvgComponent = iconsMap[iconType];

    if (isDev() && !SvgComponent) {
      console.warn(`Icon "${iconType}" not found. Available icons:`, Object.keys(iconsMap));
      return null;
    }

    const extraAttributes: React.HTMLAttributes<any> = {};
    if (ariaLabel) {
      extraAttributes['aria-label'] = ariaLabel;
      extraAttributes.role = 'img';
    }

    return SvgComponent ? (
      <SvgComponent className={className} aria-hidden={isAriaHidden} {...extraAttributes}>
        {title && <title>{title}</title>}
      </SvgComponent>
    ) : null;
  }
}
